import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M7.003.024C4.378.224 1.98 1.847.806 4.216a7.582 7.582 0 0 0 .717 7.959c1.298 1.737 3.251 2.821 5.467 3.032 1.824.173 3.888-.447 5.335-1.605l.166-.132 2.234 2.23c2.01 2.007 2.25 2.236 2.395 2.274a.693.693 0 0 0 .854-.854c-.038-.145-.267-.386-2.272-2.396l-2.23-2.235.132-.166c1.157-1.448 1.777-3.512 1.604-5.337-.172-1.803-.882-3.37-2.103-4.643A7.612 7.612 0 0 0 7.002.024zm1.454 1.424c.822.107 1.613.38 2.324.805 1.424.843 2.51 2.301 2.878 3.866.512 2.179-.099 4.35-1.664 5.91a6.1 6.1 0 0 1-4.377 1.809 6.153 6.153 0 0 1-4.107-1.55 6.189 6.189 0 0 1-2.114-4.674c0-1.67.64-3.21 1.826-4.397a6.023 6.023 0 0 1 2.28-1.458c.881-.33 1.983-.445 2.954-.31z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "search"}) } }